export default __webpack_public_path__ + "static/media/nfl-header-background-mobile.cfda6e77.png";